import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "11",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4EBC73",
      "fill-rule": "evenodd",
      d: "M15.54.48a.75.75 0 0 1-.02 1.06l-9.338 9a.75.75 0 0 1-1.042 0L.48 6.04a.75.75 0 0 1 1.04-1.08l4.142 3.998L14.48.46a.75.75 0 0 1 1.06.02",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }